<template>
  <div>

    <ContactFormTable
      :cols="cols"
      :isLoading="uiFlags.isFetching"
      :records="campaignForms"
      :showEmptyResult="!uiFlags.isFetching && !campaignForms.length"
    />
    <div>
      <table-footer
        :on-page-change="onPageChange"
        :current-page="Number(meta.current_page)"
        :total-count="meta.count"
        />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helperMixin from 'shared/mixins/helperMixin';
import alertMixin from 'shared/mixins/alertMixin';
import DateRangePicker from "components/ui/DateRangePicker.vue"
import moment from "moment";
import TableFooter from 'dashboard/components/widgets/TableFooter';
import SearchInput from 'dashboard/components/ui/SearchInput.vue'

import ContactFormTable from "./ContactFormTable.vue"


export default {
  components:{
    DateRangePicker,
    TableFooter,
    SearchInput,
    ContactFormTable,
  },
  mixins:[helperMixin,alertMixin],
  props:{
    contactId:{
      type: Number,
      required: true,
    },
  },
  data(){
    const endDate = new Date(); // Current date
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1); // One month ago



    return {
      dateRange: [startDate,endDate],
      // searchValue:'',
      // selectedStatus: null,
      // sortBy:null,

      cols: [
        { key: 'title', name: 'Name', visible: true, type: 'default' },
        { key: 'description', name: 'Description', visible: true, type: 'default' },
        { key: 'published', name: 'Published', visible: true, type: 'default' },
        // { key: 'status', name: 'Status', visible: true, type: 'default' },
        // { key: 'links', name: 'Links', visible: true, type: 'default' },
        // { key: 'responders_count', name: 'Responders Count', visible: true, type: 'default' },
        { key: 'actions', name: 'Actions', visible: true, type: 'default' },
      ],
    }
  },
  computed:{
    ...mapGetters({
      currentUser: 'getCurrentUser',
      // getAccount: 'accounts/getAccount',
      uiFlags: "campaigns/getUIFlagsForms",
      meta: "campaigns/getFormMeta",
      campaignForms: "campaigns/getCampaignForms",
    }),
    paginationCompute(){
      const totalPages = Math.ceil(this.meta.count / this.meta.pageSize);
      const isLastPage = this.meta.current_page >= totalPages;
      const currentCount = Math.min(this.meta.current_page * this.meta.pageSize, this.meta.count);
      // const btnText = `Load More Orders (${currentCount}/${this.meta.count})`;
      const btnText = `${this.$t('CAMPAIGN.LLM_CHATBOT.REPORT.LOAD_MORE_BTN')} (${currentCount}/${this.meta.count})`;

      return{
        isLastPage,
        btnText,
      }
    },
  },
  mounted() {
  // When revisiting the route (with <keep-alive>)
    this.fetchRecords({
        page: 1,
    });
  },
  methods:{
    async fetchRecords(newQuery={}){
      try {
        const defautQuery = {
          page: this.meta.current_page,
          page_size:  this.meta.page_size,
          contact_id: this.contactId,
          ...newQuery,
        }
        this.$store.dispatch("campaigns/fetchCampaignForms",this.cleanObject(defautQuery));
      } catch (error) {
        console.log(error);
        this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
      }
    },
    onPageChange(page){
      this.fetchRecords({page,})
    },
    // end methods
  },


}
</script>

<style>

</style>